import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { WorkspaceAccess } from '@nx-frontend/shared/types';

interface GetWorkspaceAccessParams {
  workspaceId: string;
  userId: number;
  host?: string;
}

export async function getWorkspaceAccess({
  host,
  workspaceId,
  userId,
}: GetWorkspaceAccessParams): Promise<WorkspaceAccess | null> {
  let workspaceAccess: WorkspaceAccess | null = null;
  const requestUrl = host || generalEnv.workspaceServiceUrl;

  const response = await axiosClient.get<WorkspaceAccess>(
    `${requestUrl}/v1/workspaces/${encodeURIComponent(workspaceId)}/access`,
    {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    }
  );
  workspaceAccess = response.data;

  return workspaceAccess;
}
